import { InvoiceType } from '../../models';
// TODO: this function must be removed from anywhere and deleted after backend model will be filled with this fields.
export function fixInvoiceMessage(message) {
    if (message.invoiceNumber === undefined)
        message.invoiceNumber = 'UNKNOWN invoiceNumber';
    if (message.invoiceType === undefined)
        message.invoiceType = InvoiceType.Utd1;
}
